

import Tippy from '@/components/common/Tippy.vue'
import Icon from '@/components/UntitledUI/Icon.vue'
import { ObserveVisibility } from 'vue-observe-visibility'
import DispatchEventUtils from '@/components/FileViewer/Mixins/DispatchEventUtils'
import NotificationStatusIcon from '@/components/FileViewer/Icons/NotificationStatusIcon.vue'
import EyeIcon from './Icons/EyeIcon.vue'
import EyeOffIcon from './Icons/EyeOffIcon.vue'
import ShareIcon from './Icons/ShareIcon.vue'
import PlusCircleIcon from './Icons/PlusCircleIcon.vue'
import MinusCircleIcon from './Icons/MinusCircleIcon.vue'
import MessageChatSquareIcon from './Icons/MessageChatSquareIcon.vue'
import FolderPlusIcon from './Icons/FolderPlusIcon'
import ChevronLeftIcon from './Icons/ChevronLeftIcon.vue'
import ChevronRightIcon from './Icons/ChevronRightIcon.vue'
import ScreenUtils from './Mixins/ScreenUtils.js'
import BookIcon from './Icons/BookIcon.vue'
import InfoCircleIcon from './Icons/InfoCircleIcon.vue'
import SearchMediumIcon from './Icons/SearchMediumIcon.vue'
import ZoomOutIcon from './Icons/ZoomOutIcon.vue'
import ZoomInIcon from './Icons/ZoomInIcon.vue'
import MenuButton from './MenuButton.vue'
import FileDownloadIcon from './Icons/FileDownloadIcon.vue'
import PencilLineIcon from './Icons/PencilLineIcon.vue'
import NotificationsIcon from './Icons/NotificationsIcon.vue'

export default {
    name: 'PageNavigator',
    directives: {
        ObserveVisibility
    },
    components: {
        NotificationStatusIcon,
        MenuButton,
        ShareIcon,
        MinusCircleIcon,
        PlusCircleIcon,
        MessageChatSquareIcon,
        BookIcon,
        EyeIcon,
        FolderPlusIcon,
        InfoCircleIcon,
        SearchMediumIcon,
        ZoomOutIcon,
        ZoomInIcon,
        FileDownloadIcon,
        PencilLineIcon,
        ChevronLeftIcon,
        ChevronRightIcon,
        EyeOffIcon,
        NotificationsIcon,
        Tippy,
        Icon
    },
    mixins: [ScreenUtils, DispatchEventUtils],
    props: {
        isReadMode: Boolean,
        isText: Boolean,
        isDownloadable: Boolean,
        isAllRegsOpen: Boolean,
        isNavigatorAtTheTop: Boolean,
        hasAnyRegulations: Boolean,
        hasSaudiUpdates: Boolean,
        getUpdates: Boolean
    },
    inject: ['fvAPI_SearchInFile', 'user', 'fvAPI_DownloadFile', 'fvAPI_DownloadFileLoading', 'isLogged', 'toast', 'meta'],
    data () {
        return {
            showLeft: false,
            showRight: false,
            isUpdates: false,
            currentIndex: 0,
            sections: this.meta.saudiUpdates
        }
    },
    watch: {
        getUpdates (val) {
            if (val) {
                this.showUpdates()
            }
        }
    },
    created () {
        this.$on('show-updates', this.showUpdates)
    },
    methods: {
        scrollToRight () {
            const scrollAmount = this.$refs.scrollContainer.scrollLeft + Math.ceil(this.$refs.scrollContainer.clientWidth / 2)
            this.$refs.scrollContainer.scrollTo({
                left: scrollAmount,
                behavior: 'smooth'
            })
        },
        scrollToLeft () {
            const scrollAmount = this.$refs.scrollContainer.scrollLeft - Math.ceil(this.$refs.scrollContainer.clientWidth / 2)
            this.$refs.scrollContainer.scrollTo({
                left: scrollAmount,
                behavior: 'smooth'
            })
        },
        showUpdates () {
            this.isUpdates = !this.isUpdates
            if (this.isUpdates) {
                this.currentIndex = 0
                this.dispatchSetPage(this.sections[this.currentIndex].section_id)
            } else {
                this.currentIndex = 0
                this.dispatch('FileViewer', 'show-pointer', this.currentIndex)
            }
        },
        goDown () {
            if (this.currentIndex < this.sections.length - 1) {
                this.currentIndex++
                this.dispatchSetPage(this.sections[this.currentIndex].section_id)
            } else {
                this.currentIndex = 0
                this.dispatchSetPage(this.sections[this.currentIndex].section_id)
            }
        },
        goUp () {
            if (this.currentIndex > 0) {
                this.currentIndex--
                this.dispatchSetPage(this.sections[this.currentIndex].section_id)
            } else {
                this.currentIndex = this.sections.length - 1
                this.dispatchSetPage(this.sections[this.currentIndex].section_id)
            }
        },
        dispatchSetPage (sectionId) {
            this.dispatch('FileViewer', 'set-page', sectionId)
            this.dispatch('FileViewer', 'show-pointer', sectionId)
        }
    }
}
